const DB_NAME = "WishlistDB";
const STORE_NAME = "WishlistStore";
const CACHE_KEY = "wishlist_data_cache";
const CACHE_TIME = 1000 * 60 * 20; // 20 minutos
let ITEMS_PER_PAGE = 20; // Valor padrão, será atualizado via DOM

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function saveToCache(data) {
  try {
    const db = await openDB();
    const payload = { timestamp: Date.now(), products: data };
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(payload, CACHE_KEY);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (err) {
    console.warn("Não foi possível salvar no cache.", err);
  }
}

async function getFromCache() {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(CACHE_KEY);
      request.onsuccess = () => {
        const record = request.result;
        if (!record) return resolve(null);
        if (Date.now() - record.timestamp > CACHE_TIME) {
          clearCache().then(() => resolve(null));
        } else {
          resolve(record.products);
        }
      };
      request.onerror = () => reject(request.error);
    });
  } catch (err) {
    console.warn("Erro ao ler cache.", err);
    return null;
  }
}

async function clearCache() {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete(CACHE_KEY);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (err) {
    console.warn("Erro ao limpar cache.", err);
  }
}

async function init() {
  document.addEventListener("DOMContentLoaded", async () => {
    const wishlistElement = document.querySelector("wishlist-lel");
    const containerGalery = document.querySelector(".container-galery");
    if (containerGalery && containerGalery.dataset.productsPerPage) {
      ITEMS_PER_PAGE = parseInt(containerGalery.dataset.productsPerPage) || 20;
      // ITEMS_PER_PAGE = 50;
    }

    if (wishlistElement && containerGalery) {
      const data = wishlistElement.dataset;

      // Sincroniza localStorage com o banco antes de buscar
      await syncLocalToDb(data);

      let isFromCache = true;
      let likedProducts = await getFromCache();

      if (!likedProducts) {
        likedProducts = await getProductsInWishlist(data);
        isFromCache = false;
      }

      if (
        likedProducts &&
        likedProducts.data &&
        likedProducts.data.length > 0
      ) {
        const urlParams = new URLSearchParams(window.location.search);
        const currentPage = parseInt(urlParams.get("page")) || 1;

        // Mostra o título da categoria se houver produtos
        const categoryHeader = document.querySelector(
          "[data-category-heading-container]",
        );
        if (categoryHeader) categoryHeader.style.display = "block";

        containerGalery.style.display = "grid";
        const emptyMsg = document.getElementById("wishlist-empty-message");
        if (emptyMsg) {
          emptyMsg.classList.add("hidden");
          emptyMsg.classList.remove("flex");
        }

        await insertProductCards(likedProducts, containerGalery, isFromCache);
        await updatePaginationViaProxy(likedProducts, currentPage);

        // Atualiza o contador no header
        updateWishlistCounter(likedProducts.data.length);
      } else {
        renderEmptyWishlist(containerGalery);
        updateWishlistCounter(0);
      }

      // Listener para clique no coração (descurtir e remover)
      containerGalery.addEventListener("click", async (e) => {
        const heart = e.target.closest(".iconHeart");
        if (heart) {
          e.preventDefault();
          e.stopPropagation();

          // Busca o wrapper da section ou o card para remover
          const wrapper =
            heart.closest('[id^="section-"]') ||
            heart.closest('[id^="shopify-section-"]') ||
            heart.closest("product-card");
          const productId = heart.dataset.idProduct;

          // Mostra o loading
          const loading =
            document.querySelector(".loading_wishlist") ||
            document.querySelector(".loading");
          if (loading) loading.style.display = "flex";

          // Remove o elemento pai e chama o refill
          if (wrapper) {
            wrapper.remove();
            await removeFromWishlistAndRefill(productId, data, containerGalery);
          }
        }
      });
    }
  });
}

async function removeFromWishlistAndRefill(productId, data, containerGalery) {
  try {
    const { apiUrl } = data;

    // 1. Deleta do banco
    const response = await fetch(apiUrl, {
      method: "DELETE",
      body: JSON.stringify({ productId: productId }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (!response.ok) {
      throw new Error("Erro ao deletar o produto.");
    }

    // Só apaga do localStorage se a requisição houver sido bem sucedida
    let localProducts =
      JSON.parse(localStorage.getItem("wishlist-productsIds")) || [];
    localProducts = localProducts.filter((id) => id !== productId);
    localStorage.setItem("wishlist-productsIds", JSON.stringify(localProducts));

    // Reconfigura o cache local, retirando o item dinamicamente
    let likedProducts = await getFromCache();

    if (likedProducts && likedProducts.data) {
      const itemIndex = likedProducts.data.findIndex(
        (item) => String(item.productId) === String(productId),
      );

      if (itemIndex !== -1) {
        // Remove do array em cache para que todo mundo suba 1 posição no re-cálculo
        likedProducts.data.splice(itemIndex, 1);
        await saveToCache(likedProducts);

        if (likedProducts.data.length === 0) {
          renderEmptyWishlist(containerGalery);
          updateWishlistCounter(0);
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const currentPage = parseInt(urlParams.get("page")) || 1;

        // Se houver uma página seguinte, o primeiro item dela ('subindo') estava ou passa a ocupar
        // o último index da página de acordo com limit * page - 1
        const refillIndex = currentPage * ITEMS_PER_PAGE - 1;
        const newItem = likedProducts.data[refillIndex];

        if (newItem) {
          let html = await getProductCards(newItem.product.productHandle);

          // Ajusta o index no HTML visual
          const realIndex = refillIndex + 1;
          html = html.replace(/"index":\s*\d+/, `"index": ${realIndex}`);

          containerGalery.insertAdjacentHTML("beforeend", html);
          renderLazyLoading();

          // Força coração persistido no UI
          const newCard = containerGalery.lastElementChild;
          if (newCard) forceHeartLiked(newCard);
        }
      }
      // Atualiza a paginação após remoção
      const urlParams = new URLSearchParams(window.location.search);
      const currentPage = parseInt(urlParams.get("page")) || 1;

      // Cálculo do novo total de páginas
      const newTotalPages = Math.ceil(
        likedProducts.data.length / ITEMS_PER_PAGE,
      );

      // Se a página atual ficou vazia (ex: estava na 4 e agora só existem 3), volta uma página
      if (currentPage > newTotalPages && newTotalPages > 0) {
        urlParams.set("page", newTotalPages);
        window.location.search = urlParams.toString();
        return; // Interrompe pois a página vai recarregar
      }

      await updatePaginationViaProxy(likedProducts, currentPage);

      // Atualiza o contador no header após remoção
      updateWishlistCounter(likedProducts.data.length);
    }

    // Oculta o loading após finalizar a reposição
    const loading =
      document.querySelector(".loading_wishlist") ||
      document.querySelector(".loading");
    if (loading) loading.style.display = "none";
  } catch (error) {
    console.error("Erro ao remover ou repor card:", error);
    // Garante que o loading suma mesmo em caso de erro
    const loading =
      document.querySelector(".loading_wishlist") ||
      document.querySelector(".loading");
    if (loading) loading.style.display = "none";
  }
}

function forceHeartLiked(container) {
  const hearts = container.querySelectorAll(".iconHeart");
  hearts.forEach((heart) => {
    const unchecked = heart.querySelector(".iconHeartUnchecked");
    const checked = heart.querySelector(".iconHeartChecked");
    if (unchecked) unchecked.style.display = "none";
    if (checked) checked.style.display = "block";
  });
}

async function getProductsInWishlist(data) {
  try {
    const { apiUrl } = data;
    const getResponse = await fetch(
      `${apiUrl}?limit=2000&productStatus=active`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      },
    );
    const response = await getResponse.json();
    return response;
  } catch (error) {
    throw new Error("Error to get products in wishlist", error);
  }
}

async function insertProductCards(likedProducts, containerGalery, isFromCache) {
  const dataItems = likedProducts.data;

  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(urlParams.get("page")) || 1;

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = currentPage * ITEMS_PER_PAGE;
  const pageItems = dataItems.slice(startIndex, endIndex);

  const BATCH_SIZE = 12; // quantos produtos vão ser injetados por vez

  // Processa em lotes para otimização
  for (let i = 0; i < pageItems.length; i += BATCH_SIZE) {
    const batch = pageItems.slice(i, i + BATCH_SIZE);

    const batchPromises = batch.map(async (item, batchIndex) => {
      // Se a string HTML já foi guardada na memória do item, reaproveita
      if (item.cachedHtml) {
        return item.cachedHtml;
      }

      let html = await getProductCards(item.product.productHandle);

      // Ajusta o index do card
      const realIndex = startIndex + i + batchIndex + 1;
      html = html.replace(/"index":\s*\d+/, `"index": ${realIndex}`);

      item.cachedHtml = html; // guarda pra próxima chamada caso use o cache memory
      return html;
    });

    const htmlResponses = await Promise.all(batchPromises);
    const batchHTML = htmlResponses.join("");

    // Oculta o loading a partir do primeiro lote
    if (i === 0) {
      const loading =
        document.querySelector(".loading_wishlist") ||
        document.querySelector(".loading");
      if (loading) loading.style.display = "none";
    }

    containerGalery.insertAdjacentHTML("beforeend", batchHTML);

    renderLazyLoading();

    // Garante que os corações comecem curtidos
    forceHeartLiked(containerGalery);

    if (!isFromCache) {
      await saveToCache(likedProducts);
    }
  }

  // Desativa o loading caso o slice da página não contenha nenhum produto
  if (pageItems.length === 0) {
    const loading =
      document.querySelector(".loading_wishlist") ||
      document.querySelector(".loading");
    if (loading) loading.style.display = "none";
  }

  return { success: true };
}

async function getProductCards(handle) {
  const url = `/products/${handle}?section_id=product-simple`;
  console.log(url, "<<<<<<<");
  const response = await fetch(url, { cache: "force-cache" });
  return await response.text();
}

// Chama a função de lazyLoading
function renderLazyLoading() {
  if (typeof initObserver === "function") {
    initObserver("img.__lazy_loading");
    if (window.innerWidth >= 768) {
      initObserver("img.__lazy_hover");
    } else {
      initObserver("img.__lazy_carrossel_image");
    }
  }
}

async function syncLocalToDb(data) {
  try {
    const productsIds =
      JSON.parse(localStorage?.getItem("wishlist-productsIds")) || [];
    if (productsIds.length === 0) return;

    const response = await fetch(`${data.apiUrl}/local-to-db`, {
      method: "POST",
      body: JSON.stringify({
        productsIds: productsIds,
        name: data.customerName,
        email: data.customerEmail,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });

    const jsonResponse = await response.json();

    if (!response.ok) {
      throw new Error(
        `Erro ${response.status}: ${JSON.stringify(jsonResponse)}`,
      );
    }

    localStorage.removeItem("wishlist-productsIds");
    // Limpa o cache para forçar uma nova busca com os dados integrados
    await clearCache();
  } catch (error) {
    console.error("Erro ao sincronizar wishlist local:", error);
  }
}

async function updatePaginationViaProxy(likedProducts, currentPage) {
  const container = document.getElementById("wishlist-pagination-container");
  if (
    !container ||
    !likedProducts ||
    !likedProducts.data ||
    likedProducts.data.length === 0
  ) {
    if (container) container.innerHTML = "";
    return;
  }

  try {
    // Extrai apenas os IDs numéricos dos produtos
    // Se o seu ID for algo como "gid://shopify/Product/12345", pegamos só o 12345
    const ids = likedProducts.data.map((item) => {
      const idStr = String(item.productId);
      return idStr.includes("/") ? idStr.split("/").pop() : idStr;
    });

    // Criamos uma "Query de Metadados" para que o Proxy saiba o total e a página sem depender da busca nativa
    const totalItems = likedProducts.data.length;

    // Se houver apenas uma página, não renderiza a paginação e adiciona margem inferior
    const containerGalery = document.querySelector(".container-galery");
    if (totalItems <= ITEMS_PER_PAGE) {
      if (container) container.innerHTML = "";
      if (containerGalery) containerGalery.style.marginBottom = "32px";
      return;
    }

    if (containerGalery) containerGalery.style.marginBottom = "0px";

    const metadataQuery = `TOTAL_${totalItems}_PAGE_${currentPage}_LIMIT_${ITEMS_PER_PAGE}`;

    // Busca o HTML da paginação através da seção proxy enviando os metadados
    const response = await fetch(
      `/search?q=${encodeURIComponent(metadataQuery)}&section_id=wishlist-pagination-proxy&page=${currentPage}`,
    );
    let html = await response.text();

    if (html && html.trim().length > 0) {
      // Corrigimos os links para que apontem para a página atual de favoritos em vez de /search
      const currentPath = window.location.pathname;
      const fixedHtml = html.replace(/\/search/g, currentPath);
      container.innerHTML = fixedHtml;
    } else {
      container.innerHTML = "";
    }
  } catch (error) {
    console.error("Erro ao carregar paginação via proxy:", error);
  }
}

function updateWishlistCounter(count) {
  const desktopCounter = document.getElementById("wishlist-counter-desktop");
  const mobileCounter = document.getElementById("wishlist-counter-mobile");

  [desktopCounter, mobileCounter].forEach((counter) => {
    if (counter) {
      const span = counter.querySelector("span");
      if (span) span.textContent = count > 9 ? "+9" : count;

      if (count > 0) {
        counter.classList.remove("hidden");
        counter.classList.add("flex");
      } else {
        counter.classList.add("hidden");
        counter.classList.remove("flex");
      }
    }
  });
}

function renderEmptyWishlist(container) {
  container.style.display = "none";

  const emptyMessage = document.getElementById("wishlist-empty-message");
  if (emptyMessage) {
    emptyMessage.classList.remove("hidden");
    emptyMessage.classList.add("flex");
  }

  // Oculta o título da categoria
  const categoryHeader = document.querySelector(
    "[data-category-heading-container]",
  );
  if (categoryHeader) categoryHeader.style.display = "none";

  // Oculta o loading
  const loading =
    document.querySelector(".loading_wishlist") ||
    document.querySelector(".loading");
  if (loading) loading.style.display = "none";
}

init();
